import React from 'react'

export interface ShipmentDetailProps {
  children: React.ReactNode
  label: string
}

export const ShipmentDetail: React.FC<ShipmentDetailProps> = ({
  label,
  children,
}) => {
  return (
    <div className="flex h-14 flex-row items-center gap-4 text-indigo-50">
      <span className="font-heading text-md w-[307px]">{label}</span>
      <span className={typeof children === 'string' ? 'font-body text-sm' : ''}>
        {children}
      </span>
    </div>
  )
}

export default ShipmentDetail
